import { themes } from "prism-react-renderer";
import { useIsDarkMode } from "~/hooks/useIsDarkMode";

export const codeTheme = themes.vsLight;

/**
 * The Prism theme matching the active colour scheme.
 *
 * Dark mode is Next-Gen-only (`ManifoldNextGenLayout` owns the `.dark` class on
 * `<html>`), so surfaces outside `pages/manifold-nextgen` can keep reading the
 * light `codeTheme` directly.
 */
export const useCodeTheme = () => (useIsDarkMode() ? themes.vsDark : themes.vsLight);
